import { render, staticRenderFns } from "./PictoArrow.vue?vue&type=template&id=0fa3e915&"
import script from "./PictoArrow.vue?vue&type=script&lang=js&"
export * from "./PictoArrow.vue?vue&type=script&lang=js&"
import style0 from "./PictoArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports